<template>
    <div>
        <div :class="{'show': showLikeCommentToggle }" class="modal fade">
            <div class="modal-dialog">
                <div class="modal-content modal-content-lg">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4 fw-500">{{likeCommentTitle}}
                        </h5>
                        <button type="button" class="close" @click="showLikeCommentToggle = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="border-bottom pb-2">
                            <a class="btn btn-primary btn-md btn-icon rounded-circle waves-effect waves-themed">
                                <i class="fas " :class="likeCommentAction == 'likes' ? 'fa-thumbs-up' : 'fa-comment-alt'"></i>
                            </a>
                            <span class="ml-3 text-primary fw-700">{{likeCommentItems.length}}</span>
                        </div>
                        <div v-if="isBroadcastLikeCommentSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div v-if="!isBroadcastLikeCommentSpinnerShow && likeCommentItems.length != 0" class="row">
                            <div class="col-sm-12 overflow-auto">
                                <table class="table m-0">
                                    <tr v-for="(item, i) in likeCommentItems" :key="i" :class="{'border-bottom': (i+1) != likeCommentItems.length}">
                                        <td class="align-middle">
                                            <a class="btn btn-outline-primary btn-md btn-icon rounded-circle waves-effect waves-themed">
                                                <i class="fal " :class="likeCommentAction == 'likes' ? 'fa-thumbs-up' : 'fa-comment-alt'"></i>
                                            </a>
                                        </td>
                                        <td class="align-middle">
                                            <p v-if="likeCommentAction == 'likes'" class="text-dark fw-500 mb-0">{{item.memberDisplayName}}</p>
                                            <div v-else class="mb-0 alert alert-primary p-2">
                                                <p class="text-dark fw-500 mb-0">{{item.memberDisplayName}}</p>
                                                {{item.comment}}
                                            </div>
                                        </td>
                                        <td class="align-middle text-right">
                                            <span class="badge badge-primary">+{{item.mobile}}</span>
                                        </td>
                                        <td v-if="likeCommentAction != 'likes'" class="align-middle text-right">
                                            <a class="text-primary link" @click="showDelete(item)">
                                                <i class="fal fa-trash"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div v-if="!isBroadcastLikeCommentSpinnerShow && likeCommentItems.length == 0" class="no-comments-container d-flex justify-content-center align-items-center">
                            <div class="d-block text-center">
                                <i v-if="likeCommentAction == 'comment'" class="fas fa-comments-alt d-block display-3"></i>
                                <div class="mb-2" v-else>
                                    <a class="btn btn-default btn-md btn-icon rounded-circle">
                                        <i class="fas fa-thumbs-up "></i>
                                    </a>
                                    <span class="ml-3 text-default fw-700">0</span>
                                </div>
                                <span class="fs-xl fw-500">{{$t('salon_report.broadcast.no_like_comment', {'action': likeCommentAction == 'likes' ? $t('table.header.like') : $t('table.header.comment')})}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <deleteModal ref="deleteModal" @performConfirmAction="performDeleteAction"></deleteModal>
    </div>
</template>
<script>
import DeleteModal from './../../Delete_Modal.vue'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: "broadcastLikeComment",
    components:{
        DeleteModal
    },
    data(){
        return{
            bcastID: 0,
            likeCommentID: 0,
            isBroadcastLikeCommentSpinnerShow: false,
            showLikeCommentToggle: false, likeCommentTitle: "", likeCommentAction: "",
            likeCommentItems: [],
        }
    },
    methods:{
        closeModal(isError){
            if(!isError){
                this.getBroadcastLikeComment(this.bcastID, this.likeCommentAction)
            }
            this.$refs.deleteModal.toggleModal = false
            this.$parent.$parent.isModalShow = false;
        },
        getBroadcastLikeComment(bcastID, action){
            let $vm = this;
            const url = this.$api.BROADCAST + "/" + bcastID + "/" + action
            
            this.bcastID = bcastID
            this.likeCommentItems = []
            this.likeCommentAction = action;
            this.isBroadcastLikeCommentSpinnerShow = true;
            
            $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                $vm.likeCommentItems = response.data.result;
                $vm.isBroadcastLikeCommentSpinnerShow = false
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == "Invalid Token"){
                    handleSessionExpired();   
                }
            })
            var _action = action == "likes" ? this.$i18n.t('table.header.like') : this.$i18n.t('table.header.comment')
            this.likeCommentTitle = this.$i18n.t('salon_report.broadcast.header_like_comment', {'action': _action})
            this.showLikeCommentToggle = true;
        },
        showDelete(item){
            var action = this.likeCommentAction == "likes" ? this.$i18n.t('table.header.like') : this.$i18n.t('table.header.comment')
            this.likeCommentID = this.likeCommentAction == "likes" ? item.likesID : item.commentID

            var title = this.$i18n.t('header.delete', {'item': action})
            var message = this.$i18n.t('message.confirmation.delete_like_comment',{'item': action, 'user': item.memberDisplayName})
            this.$refs.deleteModal.showModal(title, message)
        },
        performDeleteAction(){
            let $vm = this;
            
            const url = this.$api.BROADCAST + "/" + this.bcastID + "/" + this.likeCommentAction + "/" + this.likeCommentID + this.$api.DELETE;

            var action = this.likeCommentAction == "likes" ? this.$i18n.t('table.header.like') : this.$i18n.t('table.header.comment')
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                if(response.status == 200){
                    var message = action + " " + $vm.$msg.DELETE_SUCCESS
                    $vm.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
    },

}
</script>
<style scoped>
.show{
    display: block;
}
.like-comment-icon:hover{
    color: #886ab5
}
.btn-primary>i{
    color: #fff;
}
.btn-outline-primary>i{
    color: #886ab5
}
.btn-outline-primary:hover, a.btn-outline-primary:active,
.btn-outline-primary:not(:disabled):not(.disabled):active{
    cursor: default;
    background: transparent;
    color: #886ab5
}
.modal-content-lg{
    min-height: 85vh;
    max-height: 85vh;
    overflow-y: auto;
}
.no-comments-container{
    margin-top: 5em;
    opacity: .5;
}
</style>